<template>
  <div />
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import LazyLoadImagesHelper from '@/helpers/global/lazyLoadImages.helper';

onMounted(() => {
  LazyLoadImagesHelper.init();
});
</script>
